<template>
  <div>
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <div style="display: flex; flex-direction: 'row';">
          <el-button type="primary" @click="handAdd()" size="small" style="margin-right: 10px;">新建</el-button>
          <el-upload
            ref="userExcel"
            multiple
            :on-success="excelImportSuccess"
            action="/v1/harmfulmessage/importExcel"
            class="upload-demo">
            <Button slot="trigger" type="primary">导入</Button>
          </el-upload>
        </div>

        <Input
          search
          enter-button
          placeholder=" 请输入名称/说明内容"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px"/>
      </div>
      <div style="margin-top: 20px;">
        <Table :columns="columns1" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <el-link type="primary" size="small" style="margin-right: 5px" @click="edit(row)">编辑</el-link>|
            <el-link type="danger" size="small" @click="remove(row)">删除</el-link>
          </template>
        </Table>
        <Page
          style="float: right;margin-top: 2%"
          :total="total"
          :page-size="pageSize"
          @on-change="getData"
          :current="currentPage"/>
      </div>
    </div>

    <template>
      <Modal v-model="show" title="添加有害因素" @on-ok="submit('form')" @on-cancel="cancel">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
          <el-form-item label="代码" prop="harmfulCode">
            <el-input size="small" v-model="form.harmfulCode"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="harmfulName">
            <el-input size="small" v-model="form.harmfulName"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="harmfulName">
            <el-select v-model="form.type" placeholder="请选择设备类型" style="width: 76%">
              <el-option label="可燃气体" :value="1"></el-option>
              <el-option label="有毒气体" :value="2"></el-option>
              <el-option label="其他" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="说明" prop="describe">
            <el-input size="small" type="textarea" v-model="form.describe"></el-input>
          </el-form-item>
        </el-form>
      </Modal>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageSize: 10,
      isAdd: true,
      form: {},
      rules: {
        harmfulCode: [
          { required: true, message: "请输入代码", trigger: "change" }
        ]
      },
      show: false,
      fileNameOrTag: "",
      tableData: [],
      currentPage: 1,
      total: 0,
      columns1: [
        {
          title: "代码",
          key: "harmfulCode"
        },
        {
          title: "名称",
          key: "harmfulName"
        },
        {
          title: "类型",
          key: "typeName"
        },
        {
          title: "说明",
          key: "describe",
          width: 350
        },
        {
          title: "创建时间",
          key: "gmtCreate"
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center"
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.show = false;
      this.form = {};
    },
    submit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let url = "";
          let msg = "";
          if (this.isAdd) {
            url = "/harmfulmessage/save";
            msg = "添加成功";
          } else {
            url = "/harmfulmessage/update";
            msg = "更新成功";
          }
          this.componentsMoudel.httpRequest
            .getRequestHander(url)
            .openLoad()
            .startPost(this.form)
            .then(res => {
              this.$Message.success(msg);
              this.cancel();
              this.getData(this.currentPage);
            });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    edit(row) {
      this.isAdd = false;
      this.show = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    remove(val) {
      // console.log(val)
      this.$confirm(`删除 ${val.harmfulName}, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander("/harmfulmessage/delete/" + val.id)
            .openLoad()
            .startDel()
            .then(res => {
              if (this.tableData.length <= 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.$message.success("删除成功");
              this.getData(this.currentPage);
            });
        })
        .catch(() => {
          return;
        });
    },
    handAdd() {
      this.isAdd = true;
      this.show = true;
    },
    excelImportSuccess: function() {
      this.$refs.userExcel.clearFiles();
      this.getData(1);
    },
    getData(page) {
      this.currentPage = page;
      this.componentsMoudel.httpRequest
        .getRequestHander(
          "/harmfulmessage/search" +
            "?limit=" +
            this.pageSize +
            "&curPage=" +
            this.currentPage +
            "&searchParam=" +
            this.fileNameOrTag
        )
        .openLoad()
        .startGet()
        .then(res => {
          this.tableData = res.body.data;
          this.tableData.map((item)=>{
            if(item.type==1){
              item.typeName="可燃气体";
            }else if (item.type==2){
              item.typeName="有毒气体";
            }else {
              item.typeName="其他";
            }
          })
          // this.currentPage = res.body.page;
          this.total = res.body.cum;
        });
    }
  },
  mounted() {
    this.getData(1);
  }
};
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
</style>
